import React, { useContext } from 'react'
import { store } from '../../stores/pages'
import classNames from 'classnames'
import { Button } from 'reactstrap'

export default function Sidebar({children}) {
  const { mobileSidebar, viewingPreview, showPublish, actions, dispatch } = useContext(store)

  const sidebarClasses = classNames({
    "producer-form": true,
    "mobile-previewing": mobileSidebar,
    "d-none": viewingPreview && !showPublish,
  })

  return (
    <div className={sidebarClasses}>
      {children}
      <Button
        color="primary"
        size="lg"
        className="producer-mobile-action-button"
        onClick={(e) => {
          e.preventDefault()

          dispatch({ type: actions.TOGGLE_MOBILE_SIDEBAR })
        }}
      >
        {viewingPreview ? 'View Preview' : 'Edit Page Content'}
      </Button>
    </div>
  )
}
